import { extends as _extends, objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { forwardRef, useMemo } from 'react';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import { ArtworkContactProfile } from '../artwork/artwork-contact-profile.esm.js';

var _excluded = ["imageTitle", "imageAlt", "imageSrc", "initials", "size", "loading", "imageRef", "className", "testId"];
var PrivateAvatar = /*#__PURE__*/forwardRef(function Avatar(props, ref) {
  var theme = useComponentTheme('Avatar');
  var _props = _objectSpread2({}, props),
    imageTitle = _props.imageTitle,
    imageAlt = _props.imageAlt,
    imageSrc = _props.imageSrc,
    initials = _props.initials,
    _props$size = _props.size,
    size = _props$size === void 0 ? 'xs' : _props$size,
    loading = _props.loading,
    imageRef = _props.imageRef,
    className = _props.className,
    testId = _props.testId,
    rest = _objectWithoutProperties(_props, _excluded);
  // const id = usePropId(props.id)
  var wrapperClasses = useMemo(function () {
    return theme.base({
      className: className,
      size: size
    });
  }, [theme, size, className]);
  return /*#__PURE__*/React.createElement("div", _extends({
    // id={id}
    ref: ref,
    className: "csg-tw-avatar-image-wrapper relative overflow-hidden bg-neutral-subtlest ".concat(wrapperClasses),
    "data-testid": testId
  }, rest), imageSrc && /*#__PURE__*/React.createElement("img", {
    className: 'csg-tw-avatar-image absolute left-0 top-0 z-[0] h-auto min-h-full w-full max-w-full object-cover',
    src: imageSrc,
    alt: imageAlt,
    title: imageTitle,
    ref: imageRef,
    loading: loading
  }), initials ? /*#__PURE__*/React.createElement("div", {
    className: 'csg-tw-avatar-image flex h-auto min-h-full w-full max-w-full items-center justify-center'
  }, initials) : /*#__PURE__*/React.createElement(ArtworkContactProfile, {
    className: 'h-auto min-h-full w-full max-w-full'
  }));
});
var Avatar = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(PrivateAvatar, _extends({
    ref: ref
  }, props));
});
Avatar.displayName = 'Avatar';

export { PrivateAvatar, Avatar as default };
//# sourceMappingURL=avatar.esm.js.map
